import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Player} from '../../../../domain/player';
import {GameService} from '../../../game.service';
import {Game} from '../../../../domain/game';

@Component({
  selector: 'sg-endquestion-anxchoice',
  templateUrl: './endquestion-anxchoice.component.html',
  styleUrls: ['./endquestion-anxchoice.component.scss']
})
export class EndquestionAnxchoiceComponent {

  constructor(
    private gameService: GameService) {
  }

  @Input() players: Player[];
  @Input() game: Game;
  @Output() endquestionsAnxchoiceChange = new EventEmitter();

  get laatsteSpeler(): boolean {
    this.lastPlayer = true;
    for (let i = 0; i < this.players.length; i++) {
      if (this.players[i].anxChoiceAfter == null) {
        this.lastPlayer = false;
      }
    }
    return this.lastPlayer;
  }

  chosenPlayer = 0;
  frameSubscript = ['DOODSBANG, VERPEST MIJN LEVEN', 'DOOD NEE! WEG ERMEE!', 'VIND T MAAR NIKS', 'THIS IS NOT HAPPENING', 'HOORT ERBIJ, IS NIET ANDERS', 'GEEN ENKEL PROBLEEM', 'SUPER DAT DE DOOD BESTAAT!'];
  showEaDialog = false;
  lastPlayer = false;
  player: Player;

  selectedPlayer(i) {
    this.chosenPlayer = i;
  }

  gekozenFrame(i) {
    this.players[this.chosenPlayer].anxChoiceAfter = i;
  }

  nextPlayer() {
    if (this.lastPlayer) {
      // UPDATE GAME EN DOOR
      this.gameService.updateGame(this.game).subscribe(game => {
        this.game = game;
      });
      this.endquestionsAnxchoiceChange.emit(null);
      this.showEaDialog = true;
    } else {
      // VOLGENDE SPELER
      this.chosenPlayer += 1;
      if (this.chosenPlayer >= this.players.length) {
        this.chosenPlayer = 0;
      }
    }
  }

  dialogKeuzeFunc($event) {
    if ($event != null) {
      // GA DOOR NAAR FEEDBACK
      this.endquestionsAnxchoiceChange.emit();
      this.showEaDialog = true;
    } else {
      // OVERSLAAN
      this.showEaDialog = false;
    }
  }
}
